
import { Box, Typography, Grid } from "@mui/material";
import useTracking from "../hooks/useTracking";

export default function AppDownloadSection() {



    const { ref, handleClick } = useTracking("AppDownloadSection");
 

  return (

    <Box ref={ref} sx={{mx:"20px"}}>

    <Box
      sx={{
        position: "relative",
        backgroundImage: "url('/img1/banner.jpg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        borderRadius: "10px",
        mt: 2,
        mb:2,
        color: "white",
        display: "flex",
        minHeight: { xs: "auto", md: "auto" },

        px: { xs: 2, sm: 2, md: 8 },
        py: { xs: 2, sm: 4, md: 8 },
        borderRadius:'10px'
      }}
    >
      <Grid container>
        {/* LEFT SIDE TEXT */}
        <Grid item xs={6} md={6}>
          <Typography
            variant="h3"
            sx={{
              fontWeight: "bold",
              color: "#f7ef6d",
              mb: { xs: 2, sm: 2 },
              fontSize: { xs: "18px", md: "2.5rem" },
              textAlign: 'left',
              fontFamily: "poppin"
            }}
          >
            Start Shopping your favorite brands from Dubai
          </Typography>

          <Typography
            variant="body1"
            sx={{
              color: "#f7ef6d",
              mb: { xs: 2, sm: 2 },
              // maxWidth: "420px",
              fontSize: { xs: "15px", md: "1.1rem" },
              textAlign: 'left',
              fontFamily: "poppin"
            }}
          >
            Download App Now !
          </Typography>

          <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap", mt: { xs: 5, sm: 5, md: 15 } }}>
            <Box
              component="img"
              src="/img1/Appstorebanner.png"
              alt="App Store"
              sx={{ width: { xs: 60,sm:70, md: 120 }, cursor: "pointer" }}
             onClick={() => {
                  window.open(
                    "https://apps.apple.com/in/app/yubai/id6751202148",
                    "_blank"
                  );
                  handleClick("appstore_banner_clicked");
                }}
              
            />
            <Box
              component="img"
              src="/img1/Playstorebanner.png"
              alt="Google Play"
              sx={{ width: { xs: 60,sm:70, md: 120 }, cursor: "pointer", objectFit: 'contain' }}
              onClick={() => {
                  window.open(
                    "https://play.google.com/store/apps/details?id=com.yubai.app",
                    "_blank"
                  );
                  handleClick("playstore_banner_clicked");
                }}
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
    </Box>

  );
}

// import { Box, Typography } from "@mui/material";

// export default function AppDownloadSection() {
//   return (
//     <Box sx={{ mt: "20px", position: "relative" }}>
//       {/* Background Image */}
//       <Box
//         component="img"
//         src="/img1/banner.jpg"
//         alt="App download banner"
//         sx={{
//           width: "100%",
//           height: { xs: 190, sm: 300, md: 400 }, 
//           objectFit: "cover",
//           borderRadius: 2,
//         }}
//       />

//       {/* Text Overlay */}
//       <Box
//         sx={{
//           position: "absolute",
//           top: { xs: "38%",sm:"40%", md: "30%" }, 
//           left: { xs: "29%",sm:"30%", md: "0%" }, // center on mobile, left align on desktop
//           transform: { xs: "translate(-50%, -50%)", md: "translateY(-50%)" },
//           textAlign: { xs: "left", md: "left" },
//           color: "#fff",
//           px: { xs: 2, sm: 4 },
//           width:{xs:"50%",sm:"50%",md:"40%"}
//         }}
//       >
//         <Typography
//           variant="h4"
//           sx={{
//             fontWeight: 800,
//             fontSize: { xs: "18px", sm: "24px", md: "32px" },
//             mb: 2,
//             color: "#f7ef6d",
//             fontFamily: "Poppins, sans-serif",
//           }}
//         >
//           Start Shopping your favorite brands from Dubai
//         </Typography>

//         <Typography
//           variant="body1"
//           sx={{
//             fontSize: { xs: "14px", sm: "16px", md: "18px" },
//             fontFamily: "Poppins, sans-serif",
//             color: "#f7ef6d",
//           }}
//         >
//           Download App Now!
//         </Typography>
//       </Box>
//     </Box>
//   );
// }
